// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd30244f","343":"f9012c82","453":"b16c3107","455":"601911e9","977":"76362d41"}[chunkId] + ".chunk.js";
};